export const labelDimensions = {
  width: 1370,
  height: 482,
  fillStyle: "#FFFFFF"
};

export const framedDimensions = {
  width: 2480, // 210mm at 300dpi
  height: 1748, // 148mm at 300dpi

  paddingLeft: 594,
  paddingTop: 589,

  fillStyle: "#FFFFFF"
};

export const DOMAINS = {
  LOCALHOST: 'localhost',
  DEV: 'labelstudio.transformcxdev.com',
  STAGE: 'diageopersonalisationstudio.diageoplatform.com',
  PROD: 'www.diageopersonalisationstudio.com'
}


// WEBPACK FOOTER //
// ./src/misc/constants.js